var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button-line',_vm._b({attrs:{"items":[
    {
        label: _vm.$ucfirst(_vm.$t(_vm.afterFirstEncounter ? 'journeyProgress.progress' : 'journeyBehaviourChangeGoals.status')),
        route: {
            name: 'PatientRecordSmokingProgress',
            params: { patientId: _vm.patientId },
        },
    },
    {
        label: _vm.$ucfirst(_vm.$t('journeyProgress.goalSetting')),
        route: {
            name: 'PatientRecordSmokingGoalSetting',
            params: { patientId: _vm.patientId },
        },
    }
]}},'button-line',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }